export default {
  property: {
    header: 'Property Insurance',
    body: `<div class="title-sm">Strength and Stability for Your Home</div>
<p>Your home is your sanctuary. It’s a dependable shelter that keeps you and your family safe,
and it’s the place where memories are made. For most people, a house represents the biggest financial and emotional
investment they’ll ever make. With the right Property Insurance plan, you can protect your
investment and your personal property from whatever life throws your way.
</p>
<p>Every Home Insurance policy is different, and at SIG & Associates,
we’ll work with you to make sure that your policy fits the needs of yourself and your family.
Property Insurance may insure your home from the following types of damage:</p>

<ul>
<li>Fire and Lightning</li>
<li>Collisions from Vehicles or Aircraft</li>
<li>Hail</li>
<li>Sewer/Drain Backup</li>
<li>Windstorm</li>
<li>Vandalism</li>
<li>Volcanic Eruption</li>
<li>Smoke</li>
<li>Freezing Conditions or Snow</li>
</ul>

<div class="title-sm">Property Insurance Options to Consider</div>
<p>There are many additional coverage types that are available to safeguard your home and belongings,
and it’s important to talk with a representative from SIG & Associates who can help you find the right policy.</p>
<p>Options such as <b>Personal Property Insurance</b> and <b>Flood</b> or <b>Earthquake Insurance</b> may not fall under a standard Homeowners policy.
In the event of an accident or theft, Personal Property can pay the actual cash value or replacement
cost of personal content items or articles like furniture, appliances, and clothing.</p>
<p>Other items that may be included are <b>Builder’s Risk</b> while your home is being built or
reconstructed, and insurance for damage to pertinent/detached structures.</p>
<p>Another important feature to consider in your Homeowners policy is <b>Dwelling Replacement Coverage</b>.
If a fire or other accident leaves your home a “total loss,”
this coverage provides for the cost of replacing your home at its current value, rebuilding to code, and Ordinance & Law.</p>
<p>As is the case with many other features of Home Insurance, additional coverage can vary greatly depending on your policy,
 which is why it’s important to discuss your individual insurance options with SIG & Associates before making a decision.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  'high-value': {
    header: 'Building Protection for Wichita Falls Residents with High Net Worth Homes',
    body: `<div class="title-sm">Security On and Off the Road</div>
<p>A home symbolizes family, comfort, and security. It serves as a reflection of the individuals residing within
its confines – from the exterior framework to the interior atmosphere. However, a home also symbolizes an investment.
For homeowners in Wichita Falls and the surrounding communities,
this investment may exceed the value insured under a standard homeowners policy.</p>
<p>At SIG & Associates, we know that life is full of surprises, and with Comprehensive Coverage you can be prepared for all of them.
Our team of asset protection specialists can prepare a plan that works for you with a variety of impressive features to
insure your car against damages or loss resulting from:</p>

<div class="title-sm">Keeping High Value Homes Secure</div>
<p>As an independent agency, we have the ability to truly put clients first and we have strong relationships
with a collection of established carriers and underwriters. After consulting with clients, we turn to providers for
the best policy forms and price. Often, our clients are able to bundle their coverage for additional savings.</p>
<p>Homeowners insurance tailored for high net worth clientele contains all the coverage offered under a traditional homeowners policy.
However, the difference resides within the supplementary security supplied.
A high value homeowners policy can ensure your home is rebuilt to its previous state or uncapped value – if extensive damaged occurs.</p>
<p>For your personal belongings, a traditional homeowners policy caps coverage for a variety of items, including jewelry, furs, and fine arts.
This isn’t sufficient if the value of your belongings exceeds the coverage limits.
Agents may recommend purchasing additional endorsements for these high-value items; however, through high value homeowners insurance,
you can secure all items without the inefficiency of endorsements.</p>
<p>For more information on the insurance products and services we provide, please contact us at your convenience.</p>

<div class="title-sm">Agents Architecting Adequate Insurance Coverage</div>
<p>At SIG & Associates, we are dedicated to serving our clients however we can.
Each high-value home we insure is distinct, as are the clients who own them.
We work one-on-one with these individuals to confirm their expectations are exceeded.
Service continues long after the policy purchasing process and we make a point to be available for our clients at all times.
Don’t let your wealth of assets remain unprotected from risk.
If you’re ready to begin building an appropriate homeowners policy, request a quote.</p>

<div class="title-sm">Additional Resources</div>
<ul>
<li class="ext-link"><a href="http://www.iii.org/article/how-much-homeowners-insurance-do-i-need" target="_blank">
Details Regarding Homeowners Insurance - Insurance Information Institute<i style="margin-left: 10px" class="fa fa-external-link"></i></a></li>
<li class="ext-link">
<a href="http://www.insureuonline.org/consumer_guide_home.pdf" target="_blank">Homeowners Insurance Purchasing Guide -
The National Association of Insurance Commissioners<i style="margin-left: 10px" class="fa fa-external-link"></i></a></li>
</ul>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  'home-owner': {
    header: 'Homeowners Liability',
    body: `<div class="title-sm">Protect Yourself, Your Home, and Your Finances</div>
<p>Accidents can happen, even at home. If someone were to claim an injury on your property,
there’s no stopping them from affecting your finances, your house, or anything else you own that can be labeled as compensation.
As the property owner, you could be held fully responsible for injuries to others that occur due to
hazardous conditions such as poor lighting, floor hazards, or falls resulting from snow or ice.</p>
<p>With a Homeowners Liability policy from SIG & Associates, you can ensure the security of your finances and the safety
of your family in the event of an accident. For serious injuries, including casualties,
you may be responsible for paying large medical bills and even court costs if you are sued.
This policy works to protect you in a variety of situations, including:</p>

<ul>
<li>Claims for property damage</li>
<li>Claims for injury to others (either on or off the premises)</li>
<li>Liability defense costs</li>
<li>Medical expenses for injuries to others</li>
</ul>

<p>Having the proper Homeowners Liability Insurance for your home will prepare you for future accidents and
help preserve your hard-earned assets and finances. Talk with a representative from SIG & Associates
to determine the right amount of coverage to keep you protected today.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  renters: {
    header: 'Renters Insurance',
    body: `<div class="title-sm">Belongings Hold Memories. Make Sure They’re Safe</div>
<p>If you rent an apartment, house, condo, or even a dorm room, you may not think you need insurance.
But in the event that fire, theft, or vandalism damages your property,
it’s unlikely that your landlord will pay to replace your belongings.</p>
<p>At SIG & Associates, we know that you’ve most likely invested a lot of time and money in your personal property,
and it’s up to you to take care of it. Having a Renters Insurance, or Tenants Insurance,
policy can pay for the cost of replacing your belongings if they are damaged due to a covered accident, or if they’re stolen.</p>
<p>Depending on your policy, your insurance will pay to replace items using one of two methods:
<b>Actual Cash Value (ACV)</b> or <b>Replacement Cost</b>. With ACV coverage, your belongings are insured only for the amount in which they are currently worth,
while Replacement Cost will pay for the expense of replacing the items with brand new ones.</p>

<div class="title-sm">Additional Insurance Options</div>
<p>Also included in your Renters Insurance is <b>Liability Coverage</b> to safeguard yourself from injury claims that occur in your home.
If someone gets hurt on your property, your insurance can pay the related medical payments and expenses,
and provide for the cost of legal support if you are sued.</p>
<p>In the event that a fire or other damage makes your residence uninhabitable and places you in a “loss of use” situation,
your Renters Insurance may temporarily reimburse you for the cost of another residence in which to live.</p>
<p>Representatives from SIG & Associates are committed to working with you
to design a policy that ensures you get the options you want at a price you can afford.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  condo: {
    header: 'Condo Insurance',
    body: `
<div class="title-sm">Protect More Than Just Your Possessions</div>
<p>For many, a condo is a great alternative to living in an apartment or a home, and can offer more space,
more living area, and more amenities. But since a condo is a special kind of residence, it requires its own insurance policy.</p>
<p>With Condo Insurance from SIG & Associates, you can extend your protection past that of what your condo community provides.
It helps pay for the replacement of your personal belongings while offering basic liability to cover bodily injury or property damage.
And unlike Renters Insurance, Condo Owners Insurance covers any damage done to the interior of your unit.
For any interior damage, your insurance may be used to pay for the expense of
fixing or replacing items like drywall, flooring, light fixtures, and more.</p>
<p>A Condominium Insurance policy includes other great features like guest medical protection,
which pays for the medical expenses of friends and visitors who are injured on your property.
In the event a fire or other disaster puts your condo out of commission, additional living expenses coverage
may reimburse you for cost of temporary housing while your unit is being fixed.</p>
<p>Contact a specialist at SIG & Associates today to determine the right amount of coverage you need to keep your condo insured.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  mobile: {
    header: 'Mobile Home Insurance',
    body: `
<div class="title-sm">Specialized Security for Your Home and Property</div>
<p>At SIG & Associates, we know you’ve worked hard to turn your mobile home into the perfect living space for you and your family,
but sometimes accidents like fire or severe storms can cause major setbacks. That’s why we’re committed to serving all of your insurance needs.
With a specialized Mobile Home Insurance policy, you can safeguard your home and your belongings in the event of a covered loss.</p>
<p>Mobile Home Insurance works much like a typical Homeowners policy and typically includes features such as:</p>

<ul>
<li><b>Personal Property Protection</b> to pay for loss or damage to most of your personal items</li>
<li><b>Family Liability Protection</b> to provide legal representation against injury or property damage claims</li>
<li><b>Guest Medical Protection</b> to help cover the medical expenses for visitors injured in your home</li>
<li><b>Home & Structure Protection</b> to compensate you for building repairs after a covered accident</li>
<li><b>Additional Living Expenses</b> to reimburse you for temporary housing during reconstruction</li>
</ul>

<p>We know how special your mobile or manufactured home is to you, and we’re proud to offer to an exceptional insurance
policy that’s designed to meet your budget. You may also qualify for extra savings and discounts simply by having extra
security devices installed in your home, or by combining your Mobile Home and Auto Insurance policies.</p>
<p>Talk with an insurance specialist at SIG & Associates to learn how you can save with Mobile Home Insurance.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  's-property': {
    header: 'Scheduled Property Insurance',
    body: `
<div class="title-sm">Security for Your Most Special Possessions</div>
<p>At SIG & Associates, we know that your personal belongings are an extension of you, and oftentimes,
the things you hold onto the most are the items in which you’ve invested much time and money.
The Personal Property Insurance of your Homeowners policy will protect your valuables up to a certain amount,
but may not cover many of your most prized possessions.</p>
<p>Scheduled Personal Property (SPP) Insurance enhances your current Homeowners or Renters policy
to include items of exceptional value such as jewelry, cameras, artwork, golf equipment, firearms, musical instruments,
fine silverware, collectibles, and more. If one of your personal items is damaged or stolen due to a covered incident,
your policy will help pay for the expense of a repair or replacement.</p>
<p>Should you decide to add the premium protection of SPP Insurance, one of the specialists at
SIG & Associates will work with you to determine the replacement cost of each item you would want to have insured.</p>
<p>The items you own are unique, which is why at SIG & Associates,
we can create a policy that fits your specific needs in order to ensure the security of your most personal belongings.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  landlord: {
    header: 'Landlords Insurance',
    body: `
<div class="title-sm">Rent with Confidence</div>
<p>A rental property is an important asset that can supply you with a valuable source of income.
As the owner of an apartment, home, condo, or other property, you’ll want to be prepared in the event that your investment is damaged.
With a Landlords Insurance policy from SIG & Associates,
you’ll receive a complete degree of protection to keep yourself and your rental property insured.
</p>
<p>The proper Landlord policy can provide options from Personal Property and Liability to Medical Payments to Others
and Dwelling to accommodate the special risks that you as a property owner may face. Landlords Insurance can also cover:</p>

<ul>
<li>Damage to your property or other attached structures from a fire, natural disaster, or other peril, including damage caused by tenants</li>
<li>Expenses you may be legally obligated to pay for the property damage or medical payments in the event of injury</li>
<li>Legal counsel and fees in the event of a related lawsuit</li>
<li>Additional expenses to make up for lost income if your property needs repaired through loss of use</li>
</ul>

<p>Because of the variety of options available, an insurance specialist at SIG & Associates is available to make
sure you have the right amount of coverage for your rental property at a price that meets your budget.
With the benefits of a Landlords Insurance policy, you can rent to tenants with the confidence of knowing your investment is secure.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  flood: {
    header: 'Flood Insurance',
    body: `
<div class="title-sm">Why You Need Flood Insurance</div>
<p>Flooding is the most common and costly natural disaster in the United States, affecting every region and state.
Floods cause physical and emotional anguish, as well as financial devastation.
In fact, just one inch of water in an average sized home can cause more than $25,000 in damage.</p>
<p>Federal disaster assistance is not always the answer.
Most types of federal disaster assistance require a presidential disaster declaration and come in the form of low-interest
disaster loans that must be repaid—with interest! Only flood insurance reimburses you for flood damage,
providing the necessary funds for recovery—and you don’t have to pay it back.</p>

<div class="title-sm">Did you know?</div>
<ul>
<li>1 in 4 flood insurance claims come from outside high-risk areas.</li>
<li>Most homeowners and renters insurance policies do not cover flood damage.</li>
<li>Flood insurance coverage for homeowners living in moderate- to low-risk flood areas can be as low as $325 a year!</li>
</ul>
<p>Contact SIG & Associates today to learn more about our flood insurance coverage options.
We routinely service flood policies in Wichita Falls and the Greater Dallas-Fort Worth area.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  'home-biz': {
    header: 'In-Home Business Insurance',
    body: `
<div class="title-sm">It’s Not Just Your Home. It’s Your Living</div>
<p>Home-based businesses, both big and small, have become one of the fastest growing commercial segments in America.
As the owner of an In-Home Business, chances are your operations extend beyond the walls of your home.
At SIG & Associates, we want to help you protect the security of your business with proper coverage,
because the insurance required most likely goes beyond that of your standard Homeowners policy.</p>
<p>We know that you’ve invested hard work and countless hours into building up your In-Home Business, and because of that,
SIG & Associates wants to ensure that your operations continue to grow. With the right insurance policy for your business,
you can provide the special protection you need in one comprehensive policy.</p>

<p>An In-Home Business policy from SIG & Associates can cover:</p>
<ul>
<li>Professional Liability</li>
<li>Personal property used for business operations</li>
<li>Loss of income due to a covered event</li>
<li>Loss or damage to business records and inventory</li>
</ul>

<p>Depending on your business needs and living situation, you may also qualify for additional services to round out your
In-Home Business Insurance, including combined coverage with your Homeowners policy.</p>
<p>Talk to a representative at SIG & Associates today to create the perfect plan to address all of your business needs.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/homeHelper.js